/* eslint-disable */
/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * Run `npm run generate-api` to regenerate.
 */
import { z } from 'zod';

import { zEnumWithUnknownFallback, zRequired } from '@/shared/redux/api/utils/zod-helpers';

export const offboardingValidators: Record<string, z.ZodTypeAny> = {
  "CreateOffboarding": z.object({ "createOffboarding": z.object({ "offboardingId": z.string(), "deactivationTimestamp": zRequired, "dataPurgeTimestamp": zRequired, "tenantReactivated": z.boolean().nullish(), "objectVersion": z.number().int().nullish() }) }),
  "DeleteOffboarding": z.object({ "deleteOffboarding": z.string().nullish() }),
  "ReadOffboarding": z.object({ "readAllOffboardings": z.object({ "pages": z.number().int(), "itemCount": z.number().int(), "items": z.array(z.object({ "offboardingId": z.string(), "deactivationTimestamp": zRequired, "dataPurgeTimestamp": zRequired, "tenantReactivated": z.boolean().nullish(), "objectVersion": z.number().int().nullish() }).nullish()) }) }),
};
